import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";

export default function ResultsInfo() {
    const { currentShortcodes, selectedItems } = useRulesContext();
    return (
        <div className="px-4 sm:px-6 py-3 bg-white border-b border-gray-200">
            <div className="flex items-center justify-between text-sm text-gray-600">
                <span>
                    {currentShortcodes.length}{" "}
                    {__("item", "wpbean-quantity-controls-for-woocommerce")}
                    {currentShortcodes.length !== 1 ? "s" : ""}
                </span>
                {selectedItems.size > 0 && (
                    <span>
                        {selectedItems.size}{" "}
                        {__(
                            "selected",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </span>
                )}
            </div>
        </div>
    );
}
